<template>
  <div class="preview-question__range">
    <label class="preview-question__label"
      >{{ item.question }} <span v-if="item.isRowAnswerRequired">*</span></label
    >
    
    <table class="ranking-scale-table mb-3">
      <thead>
        <tr>
          <th></th>
          <th v-for="choice in item.ratingItems.choices" :key="choice">
            {{ choice }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(label, indexLabel) in item.ratingItems.labels" :key="label">
          <td>{{ label }}</td>
          <td v-for="(choice, indexChoice) in item.ratingItems.choices" :key="choice">
            <div class="d-flex justify-center" >
              <input 
                type="radio" 
                :name="`rd-${item.id}-${indexLabel}`" 
                :id="`rd-${item.id}-${indexLabel}-${indexChoice}`"
                :disabled="isDisabled(choice)"
                @change="setAnswers(label, choice)"
                class="preview-question__item-radio"> 
              <label :for="`rd-${item.id}-${indexLabel}-${indexChoice}`" class="ma-0"></label>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <p v-if="item.isRowAnswerRequired" class="preview-question__info">* All rows are required</p>
  </div>
</template>

<script>
export default {
  name: "PreviewQuestionsRankingScale",
  props: {
    item: {
      type: Object,
      default: Object,
    },
  },
  data() {
    return {
      answers: {},
      disabledNumbers: [],
    };
  },
  methods: {
    isDisabled(choice) {
      return this.item.onlyOneAnswerPerColumn ? this.disabledNumbers.includes(choice) : false;
    },
    setAnswers(label, choice) {
      this.answers = {
        ...this.answers,
        [label]: choice,
      };
    }
  },
  watch: {
    answers: {
      deep: true,
      handler() {
        this.disabledNumbers = Object.values(this.answers)
      },
    }
  },
};
</script>

<style lang="scss">
.ranking-scale-table {
  width: 100%;
  border-collapse: collapse;

  th, td {
    font-size: 12px;
    color: #5D6B88;
    border-bottom: 4px solid #fff;
    padding-top: 8px;
    padding-bottom: 8px;
  }

  td {
    background-color: #F3F4F7;
  }

  td:first-child {
    padding-left: 16px;
  }
}
.preview-question {
  &__info {
    font-family: "Oxygen";
    font-size: 12px;
    color: red;
    margin-bottom: 2px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  &__list-range {
    margin-top: 20px;
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
    margin-bottom: 17px;
  }
  &__item-range {
    display: none;

    &:checked + label {
      background-color: #00a5ff;
      color: #fff;
      i{
        color: #fff !important;
      }
    }

    & + label {
      height: 32px;
      width: 32px;
      background-color: #f3f4f7;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 2.5px;
      border-radius: 3px;
      margin-bottom: 5px;
      font-family: "Oxygen";
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: #5d6b88;
      cursor: pointer;
    }
		&_group{
			font-family: "Oxygen";
      font-style: normal;
      font-weight: 400;
      font-size: 10px;
      line-height: 16px;
      color: #5d6b88;
			display: flex;
    	justify-content: space-between;
		}
  }
}
</style>
